/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import classNames from "classnames";
import * as React from "react";
import { Alignment, Classes } from "../../common";
import { NAVBAR_GROUP_ALIGN_CENTER } from "../../common/errors";
import { DISPLAYNAME_PREFIX } from "../../common/props";
import { useValidateProps } from "../../hooks/useValidateProps";
// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
export var NavbarGroup = function (_a) {
    var _b = _a.align, align = _b === void 0 ? Alignment.START : _b, children = _a.children, className = _a.className, htmlProps = __rest(_a, ["align", "children", "className"]);
    var classes = classNames(Classes.NAVBAR_GROUP, Classes.alignmentClass(align), className);
    useValidateProps(function () {
        if (align === Alignment.CENTER) {
            console.warn(NAVBAR_GROUP_ALIGN_CENTER);
        }
    }, [align]);
    return (React.createElement("div", __assign({ className: classes }, htmlProps), children));
};
NavbarGroup.displayName = "".concat(DISPLAYNAME_PREFIX, ".NavbarGroup");
//# sourceMappingURL=navbarGroup.js.map